'use client';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@eliadmin/core/src/components/ui/select';
import { CATEGORY_CONFIG } from '@eliadmin/core/src/constants/category-config';
import { useCategorySort } from '@eliadmin/core/src/hooks/category/use-category-sort';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { IoMdArrowDropdown } from 'react-icons/io';

type CategorySortProps = {
  className?: string;
};

export function CategorySort(props: CategorySortProps) {
  const { className } = props;
  const { t } = useTranslations();

  const { selectedValue, onSortChange, VALUES } = useCategorySort();

  return (
    <div
      className={cn(
        'flex w-full items-center justify-end gap-4 sm:w-fit',
        'ea-category-sort',
        className,
      )}
    >
      <p className="hidden whitespace-nowrap text-base text-muted-foreground sm:block">
        {t('text2355')}
      </p>
      <div className={cn('w-full sm:w-fit', 'ea-category-sort__select-wrapper')}>
        <Select value={selectedValue} onValueChange={e => onSortChange(e)}>
          <SelectTrigger
            aria-label={t('text2355')}
            innerTriggerClassName="py-0 px-6 items-center justify-center sm:justify-between"
            className={cn(
              'flex h-14 w-full justify-center gap-4 whitespace-nowrap rounded-full bg-[#FAFAFA] px-0 text-sm font-medium text-black sm:h-12 sm:w-fit sm:justify-between sm:text-base',
              'ea-category-sort__select-trigger',
            )}
            expandIcon={<IoMdArrowDropdown className="ml-2 text-secondary" size={20} />}
            clearIcon={CATEGORY_CONFIG.categorySort.clearIcon}
          >
            <SelectValue
              placeholder={`${t('text341')}..`}
              className={cn('whitespace-nowrap', 'ea-category-sort__select-value')}
            />
          </SelectTrigger>
          <SelectContent className={cn('', 'ea-category-sort__select-content')}>
            {VALUES?.map(o => (
              <SelectItem
                key={o.value}
                value={String(o.value)}
                className={cn('', 'ea-category-sort__select-item')}
              >
                {t(o.label)}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    </div>
  );
}

export default CategorySort;
